import { render, staticRenderFns } from "./MiniProgramRuiShiLiGouWuProducts.vue?vue&type=template&id=7aa4d177&scoped=true&"
import script from "./MiniProgramRuiShiLiGouWuProducts.vue?vue&type=script&lang=js&"
export * from "./MiniProgramRuiShiLiGouWuProducts.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramRuiShiLiGouWuProducts.vue?vue&type=style&index=0&id=7aa4d177&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa4d177",
  null
  
)

export default component.exports